import { createSchemaStatementHandler } from '../../createSchemaStatementHandler';
export const respondToUserInstruction = `### User Interaction and Error Handling

This section defines how to communicate with the user, especially in situations where the request cannot be fulfilled or when specific information needs to be conveyed.

#### Guidelines for Responding to Users
- Always communicate in a positive, kind, and helpful manner. Humor is welcome where appropriate.
- Use clear and simple language to ensure the user understands the response.

#### Response Types
- **Warning**: Use when the operation requested by the user cannot be performed.
- **Information**: Use to provide helpful information or tips.

#### Syntax and Examples
- Respond with a warning:
  - Syntax: \`respond warning <message>;\`
  - Example: \`respond warning Sorry, I cannot do that;\`
- Respond with information:
  - Syntax: \`respond info <message>;\`
  - Example: \`respond info You can modify the model to fit your needs;\`

#### Implementation Notes
- Choose the response type based on the user's input and the context of the request.
- If a user's question or command is not supported by the DSL, opt for a warning response to guide them correctly.

It's very important to use only DSL statements to respond to the user's input, otherwise user will not see your message.
`;
export const stmtRespondToUser = ({ messageType, message }) => {
    return `respond ${messageType} ${message};`;
};
export const stmtForHumanRespondToUser = ({ message }) => {
    return message;
};
export const respondToUserHandler = createSchemaStatementHandler({
    type: 'respond',
    parse: line => {
        const match = /^respond (?<type>warning|info|error) (?<message>.+)/.exec(line);
        return match?.groups
            ? {
                type: 'respond',
                message: match.groups.message,
                messageType: match.groups.type,
            }
            : null;
    },
    getHumanStmt: stmt => stmtForHumanRespondToUser(stmt),
    apply: stmt => {
        // Do nothing
    },
});
//# sourceMappingURL=RespondToUserStmt.js.map